import ChatService from '@/service/chat'
export default {
    data () {
        return {
            frequent_expressions: []
        }
    },
    computed: {
        can_add_expression () {
            return this.frequent_expressions.length < 10
        }
    },
    mounted () {
        setTimeout(this.getExpressions, 500)
    },
    methods: {
        async getExpressions () {
            const { items } = await ChatService.getExpressions()
            this.frequent_expressions = items.map((item) => {
                const { autoreply_delay } = item
                const autoreply_delay_checked = autoreply_delay != null
                return {
                    ...item,
                    autoreply_delay_text: autoreply_delay_checked ?
                        autoreply_delay === 0 ? '立即' : `${autoreply_delay}秒自动回复`
                        :
                        ''
                }
            })
        },
        async delExpression (id) {
            await ChatService.deleteExpression(id)
            this.getExpressions()
        },
        async addExpression (content) {
            const is_repeated = this.frequent_expressions.some((item) => {
                return content === item.content
            })
            if (is_repeated) {
                wx.showToast({
                    title: '该条信息已存在，您无需新建',
                    icon: 'none'
                })
                return
            }
            await ChatService.createExpression(content)
            wx.showToast({
                title: '添加成功'
            })
            this.getExpressions()
        }
    }
}